import { BLOQUE } from '@/configuration/optionBlocage/optionBlocage';
import {
  ETAT_ENREGISTRE,
  NORMAL,
  REGROUPEMENT,
  PERSONNALISE,
} from '@/configuration/devisConf';
import { CATEGORIE_REGROUPEMENT } from '@/configuration/catalogue/produitConf';
import i18n from '@/i18n';
import formatDate from '@/services/general/formatDate';

export default function checkSiDevisSignable(devis, societe, desactiveControleSurLigneCmde) {
  const causesNonSignable = [];

  // Vérifier si l'état est enregistré
  if (devis.etat !== ETAT_ENREGISTRE) {
    causesNonSignable.push(i18n.t('detail.dcfSignable.etatEnregisteRequis'));
  }

  // Vérifier les lignes tempo
  const filtreLigneCommandable = (ligne) => {
    const conditionLigneNormale = ligne.type === NORMAL
      && ligne.referenceRegroupement === null
      && ligne.referencePersonnalise === null;
    const conditionLigneRegroupement = ligne.type === REGROUPEMENT
      && ligne.referencePersonnalise === null;
    const conditionReseauTempo = ligne?.typeProduit !== CATEGORIE_REGROUPEMENT
      || (ligne.typeProduit === CATEGORIE_REGROUPEMENT && ligne.etatObtenu === BLOQUE);
    const conditionLigneRgrpmtPerso = ligne.type === PERSONNALISE;
    return conditionLigneNormale
      || (conditionLigneRegroupement && conditionReseauTempo)
      || conditionLigneRgrpmtPerso;
  };
  if (!desactiveControleSurLigneCmde && devis.etat === ETAT_ENREGISTRE
      && !(devis.lignesCommande.filter(filtreLigneCommandable).length)) {
    let lignesNonCommandables = devis.lignesCommande
      .filter(ligne => ligne.typeProduit === CATEGORIE_REGROUPEMENT && ligne.etatObtenu !== BLOQUE);
    lignesNonCommandables = lignesNonCommandables.map(l => {
      return `${l.libelle} du ${formatDate(l.dateDebut)}`;
    });
    causesNonSignable.push(i18n.t('detail.dcfSignable.erreurEtatObtenuLigne',
      { libelles: lignesNonCommandables.join('\n') }));
  }
  if (devis.etat === ETAT_ENREGISTRE
      && devis.intervenants.filter(intervenant => intervenant.donneurOrdre).length !== 1) {
    causesNonSignable.push(i18n.t('detail.dcfSignable.donneurdOrdeRequis'));
  }
  if (!societe.signatureElectroniqueReferenceExterne || !societe.signatureElectroniqueToken) {
    causesNonSignable.push(i18n.t('detail.dcfSignable.signatureImpossible'));
  }
  return causesNonSignable;
}
